function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Karen Carvalho. Todos os direitos reservados.</p>
      <p>
        Siga-me no{' '}
        <a href="https://www.linkedin.com/in/karencarvalho04/" target="_blank" rel="noreferrer">
          LinkedIn
        </a>{' '}
        ·{' '}
        <a href="https://instagram.com/profkarencarvalho" target="_blank" rel="noreferrer">
          Instagram
        </a>{' '}
        ·{' '}
        <a href="https://www.tiktok.com/@profkarencarvalho?_r=1&_t=ZS-91hPDnjz8QD" target="_blank" rel="noreferrer">
          TikTok
        </a>
      </p>
    </footer>
  );
}

export default Footer;
